import { type FunctionComponent } from 'react';
import cx from 'classnames';
import { ReactComponent as ProgressNegative } from '../../../assets/svg/ProgressNegative.svg';
import { ReactComponent as ProgressPositive } from '../../../assets/svg/ProgressPositive.svg';

interface Props {
  progress: number;
  isInverted?: boolean;
}

const ProgressStatus: FunctionComponent<Props> = ({ progress, isInverted = false }) => {
  const progressClass = cx({
    positive: isInverted ? progress < 0 : progress > 0,
    negative: isInverted ? progress > 0 : progress < 0,
  });
  const containerClasses = cx('progress-status-container', progressClass);
  const valueClasses = cx('progress-value', 'text-sm-medium', progressClass);
  const iconClass = cx('progress-icon', progressClass);
  const icon = progress > 0 ? <ProgressPositive /> : <ProgressNegative />;

  return (
    !!progress && (
      <div className={containerClasses}>
        <div className={iconClass}>{icon}</div>
        <div className={valueClasses}>{progress}</div>
      </div>
    )
  );
};

export default ProgressStatus;
